import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import Notify from '../../../components/Notify/Notify';
import ModalProfileMenu from '../../../components/Modals/ModalProfileMenu/ModalProfileMenu';

import ModalPricingPlanLimit from '../../../components/Modals/ModalPricingPlanLimit/ModalPricingPlanLimit';
import ModalPricingPlanUpgrade from '../../../components/Modals/ModalPricingPlanUpgrade/ModalPricingPlanUpgrade';

import ModalInviteToApp from '../../../components/Modals/ModalInvitePeople/ModalInvitePeople';
import ModalFeedbackThanks from '../../../components/Modals/ModalFeedbackThanks/ModalFeedbackThanks';

import Sidebar from '../_components/Sidebar/Sidebar';
import Header from '../_components/Header/Header';

import { useShortKeysNavigation } from '../../../hooks/useShortKeysNavigation';

import '../MainApp.scss';
import './GuidesShortcuts.scss';

const GuidesShortcuts = () => {
    document.title = 'Guides & Shortcuts | DB Design';
    const { map: shortKeysMap } = useShortKeysNavigation();

    const [hoveredElementId, setHoveredElementId] = useState(null);

    const dispatch = useDispatch();
    const history = useHistory();


    const handleClick = (e) => {
        // history.push(`/diagram/sdf`);
    };

    return (
        <div className="dash-container guides-shortcuts-page">
            <Sidebar />
            <div className='dash-main'>

                {/* common modals */}
                <Notify viewType='main' />
                <ModalProfileMenu />

                <ModalPricingPlanLimit />
                <ModalPricingPlanUpgrade />

                <ModalInviteToApp />
                <ModalFeedbackThanks />

                {/* page components */}

                <Header title='Guides & Shortcuts'>
                    {/* <button className='dash-main-header-button prime' onClick={(e) => { handleClick(e); }}>Request</button> */}
                </Header>


                <div className='dash-main-body'>

                    <div className='selection-group_wrap'>
                        <div className='selection-group'>
                            <div className={`selection-item selected`}>Keyboard Shortcuts</div>
                            <div className={`selection-item disabled`}>Onboarding</div>
                        </div>
                    </div>


                    {/* Controls Left */}
                    <div className='shortcuts_section first'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>Controls&nbsp;</span>
                                <span>(Left)</span>
                            </div>
                            <img className="shortcuts_title_img" src="/controls_left.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Mouse select / Hand mode</div>
                            <div className='shortcuts_item_key'>
                                <span>V</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Table</div>
                            <div className='shortcuts_item_key'>
                                <span>T</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Line</div>
                            <div className='shortcuts_item_key'>
                                <span>L</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Area</div>
                            <div className='shortcuts_item_key'>
                                <span>A</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Note</div>
                            <div className='shortcuts_item_key'>
                                <span>N</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Comment</div>
                            <div className='shortcuts_item_key'>
                                <span>C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Pen</div>
                            <div className='shortcuts_item_key'>
                                <span>P</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Undo</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Z</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Redo</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Shift + Z</span>
                            </div>
                        </div>
                    </div>


                    {/* Controls Top Left */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>Controls&nbsp;</span>
                                <span>(Top Left)</span>
                            </div>
                            <img className="shortcuts_title_img" src="/controls_top_left.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Export Image</div>
                            <div className='shortcuts_item_key'>
                                <span>E</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Search</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + F</span>
                                <span>F</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Editor Panel</div>
                            <div className='shortcuts_item_key'>
                                <span>B</span>
                            </div>
                        </div>
                    </div>


                    {/* Controls Bottom Right */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>Controls&nbsp;</span>
                                <span>(Bottom Right)</span>
                            </div>
                            <img className="shortcuts_title_img" src="/controls_bottom_right.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Minimap</div>
                            <div className='shortcuts_item_key'>
                                <span>M</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Zoom in</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} +</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Zoom out</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} -</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Zoom to 100%</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + 0</span>
                            </div>
                        </div>
                    </div>



                    {/* Context Menu Table */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long'>
                                <span>Context Menu&nbsp;</span>
                                <span>(Table)</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_table.png" />
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Duplicate table</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Delete table</div>
                            <div className='shortcuts_item_key'>
                                <span>Del</span>
                            </div>
                        </div>
                    </div>



                    {/* Context Menu Delete Table */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>Context Menu&nbsp;</span>
                                <span>(Delete Table)</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_table_delete.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Yes</div>
                            <div className='shortcuts_item_key'>
                                <span>Enter</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>No</div>
                            <div className='shortcuts_item_key'>
                                <span>Esc</span>
                            </div>
                        </div>
                    </div>




                    {/* Context Menu Table Column */}
                    <div className='shortcuts_section first'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long long-d'>
                                <span>Context Menu&nbsp;</span>
                                <span>(Table Column)</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_column.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add new column below</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Enter</span>
                            </div>
                        </div>

                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Focus on column above</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Up</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Focus on column below</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Down</span>
                            </div>
                        </div>

                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Move column up</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Shift + Up</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Move column down</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Shift + Down</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Duplicate column</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Delete column</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Del</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Area</div>
                            <div className='shortcuts_item_key'>
                                <span>A</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Note</div>
                            <div className='shortcuts_item_key'>
                                <span>N</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Comment</div>
                            <div className='shortcuts_item_key'>
                                <span>C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Pen</div>
                            <div className='shortcuts_item_key'>
                                <span>P</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Undo</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Z</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Redo</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Shift + Z</span>
                            </div>
                        </div> */}
                    </div>




                    {/* Context Menu Line */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long '>
                                <span>Context Menu&nbsp;</span>
                                <span>(Line)</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_line.png" />
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Delete line</div>
                            <div className='shortcuts_item_key'>
                                <span>Del</span>
                            </div>
                        </div>
                    </div>




                    {/* Context Menu Area */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long'>
                                <span>Context Menu&nbsp;</span>
                                <span>(Area)</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_area.png" />
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Duplicate area</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Delete area</div>
                            <div className='shortcuts_item_key'>
                                {/* <span>{shortKeysMap?.CTRL} + Del</span> */}
                                <span>Del</span>
                            </div>
                        </div>
                    </div>



                    {/* Context Menu Multiselect Elements */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long'>
                                <span>Context Menu&nbsp;</span>
                                <span>(Multiselect)</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_multiselect.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Create area for selected elements</div>
                            <div className='shortcuts_item_key'>
                                <span>A</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Duplicate selected elements</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Delete selected elements</div>
                            <div className='shortcuts_item_key'>
                                {/* <span>{shortKeysMap?.CTRL} + Del</span> */}
                                <span>Del</span>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};

export default GuidesShortcuts;
